import { Box, Checkbox, Divider, Typography } from '@mui/material'
import { useContext, useState } from 'react'
import { FormContext } from '../../App'

const CustomCheckbox = ({ label, name, component, conditional_heading }) => {
  const [control, result, register, handleSubmit, watch] = useContext(
    FormContext,
  )
  const myResult = watch(name)
  const [checked, setChecked] = useState(false)
  return (
    <Box>
      <Checkbox onChange={(e) => setChecked((prev) => !prev)} />
      <label className="checkbox-label">{label}</label>
      {checked === true ? (
        <Box>
          <Typography variant="h5" sx={{ margin: '20px 0 10px 0' }}>
            {conditional_heading}
          </Typography>
          <Divider sx={{ mb: 5, mt: 2 }} />
          {component}
        </Box>
      ) : (
        ''
      )}
    </Box>
  )
}

export default CustomCheckbox
